import Select from "./Select";
import React, { useId } from "react";
import "./controls.css";
interface Props { label: string; value: string; onChange: (value: string) => void; options: readonly { value: string; label: string }[]; allLabel: string; }
export default function FilterSelect({ label, value, onChange, options, allLabel }: Props) {
  const id = useId();
  return <label className="navo-field" htmlFor={id}><span>{label}</span>
    <Select id={id} className="navo-field__input" value={value} onChange={event => onChange(event.target.value)}>
      <option value="">{allLabel}</option>
      {options.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
    </Select>
  </label>;
}
